import { config } from '../config';

/** Where both training modes' end screens send the rep: the admin portal's Training page. */
export const trainingResultsUrl = (): string => `${config.server.adminPortalUrl}/training`;

export const openTrainingResults = (): void => {
  window.location.href = trainingResultsUrl();
};
